import React from 'react';
import { Link } from 'react-router-dom';
import { FiFacebook } from 'react-icons/fi';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t, lang } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <div style={{ marginBottom: '8px' }}>
            <img src="/images/logo-cp-trans.png" alt="Cellophane & Paper" width="72" height="72" style={{ height: '72px', width: 'auto' }} loading="lazy" />
          </div>
          <p>
            Cellophane & Paper S.r.l.<br />
            Via Fuorchi snc<br />
            84030 Atena Lucana (SA)<br />
            P.IVA 04984830655
          </p>
          <div className="footer-social">
            <a href="https://www.facebook.com/CellophanePaper-1023181524370630/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FiFacebook /></a>
          </div>
        </div>

        <div className="footer-col">
          <h4>{t('footer.products')}</h4>
          <Link to="/prodotti/alimentare">{lang === 'en' ? 'Food Sector' : 'Settore Alimentare'}</Link>
          <Link to="/prodotti/macelleria">{lang === 'en' ? 'Butcher Line' : 'Linea Macelleria'}</Link>
          <Link to="/prodotti/domestica">{lang === 'en' ? 'Pro & Home' : 'Professionale & Domestica'}</Link>
          <Link to="/prodotti/confezionamento">{lang === 'en' ? 'Packaging' : 'Confezionamento'}</Link>
        </div>

        <div className="footer-col">
          <h4>{t('footer.company')}</h4>
          <Link to="/chi-siamo">{t('header.about')}</Link>
          <Link to="/prodotti">{t('header.catalog')}</Link>
          <Link to="/news">{t('header.news')}</Link>
          <Link to="/contatti#contact-form">{t('nav.contacts')}</Link>
        </div>

        <div className="footer-col">
          <h4>{t('footer.contacts')}</h4>
          <span style={{ color: 'rgba(255,255,255,0.87)', fontSize: '14px', display: 'block', padding: '4px 0' }}>
            Tel. 0975.331875
          </span>
          <span style={{ color: 'rgba(255,255,255,0.87)', fontSize: '14px', display: 'block', padding: '4px 0' }}>
            Via Fuorchi snc
          </span>
          <span style={{ color: 'rgba(255,255,255,0.87)', fontSize: '14px', display: 'block', padding: '4px 0' }}>
            84030 Atena Lucana (SA)
          </span>
          <Link to="/admin">Area Admin</Link>
        </div>
      </div>

      <div className="footer-bottom">
        <p>{t('footer.rights')}</p>
        <div>
          <Link to="/privacy">{t('footer.privacy')}</Link>
          <Link to="/cookie">{t('footer.cookie')}</Link>
        </div>
      </div>

      <div className="footer-credit">
        {t('footer.credit')}{' '}
        <a href="https://www.leafgs.it" target="_blank" rel="noopener noreferrer">Leaf Games &amp; Software S.r.l.s.</a>
      </div>
    </footer>
  );
};

export default Footer;
